/**
 * Wraps an inline row of size radios anywhere in the theme -- the cart-drawer
 * bundle upsell, the quick-add sheet, anywhere else that wants a size picker
 * without navigating to the PDP. Picking a size repoints the hidden
 * variant-id input the sibling product-form-component reads at submit.
 *
 * A custom element rather than an inline <script> in the snippet: this
 * markup often first appears in the DOM via an AJAX re-render (morphSection,
 * or a cloned <template>), not a full page load, and browsers never execute
 * <script> tags inserted that way. Custom element upgrade isn't subject to
 * that restriction -- connectedCallback fires the same whether the element
 * arrives via initial parse, innerHTML, morph, or template clone.
 */
class InlineSizePicker extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#handleChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#handleChange);
  }

  /** @param {Event} event */
  #handleChange = (event) => {
    const sizeInput = /** @type {HTMLElement} */ (event.target)?.closest('input[type="radio"]');
    if (!sizeInput) return;

    const form = this.closest('product-form-component');
    const variantIdInput = form?.querySelector('input[name="id"]');
    if (variantIdInput instanceof HTMLInputElement) {
      variantIdInput.value = /** @type {HTMLInputElement} */ (sizeInput).value;
    }
  };
}

if (!customElements.get('inline-size-picker')) {
  customElements.define('inline-size-picker', InlineSizePicker);
}
